import config from '../shared/config';
import { getJSONOneTime } from '../shared/helpers';
import { BETSLIP_SETTINGS } from 'bto-models/betslip';

/**
 * @typedef {import('bto-models/sb-settings/interfaces').SBSettings} SBSettings
 */

/**
 * Get SB settings
 * @type {()=> Promise<SBSettings>}
 */
export const getSettings = getJSONOneTime(config.baseUrl + config.endpoints.settings);
/**
 * Get Limits By Currencies
 * @type {import('bto-models/sb-settings/interfaces').TGetLimitsByCurrenciesPromise}
 */
export const getLimitsByCurrencies = getJSONOneTime(config.baseUrl + config.endpoints.getLimitsByCurrencies);

/**
 * Get SB seting if we can use freebet
 */
export const useFreebet = async () => {
	try {
		const settings = await getSettings();
		return settings.Settings[BETSLIP_SETTINGS.USE_FREEBET] === 'true';
	} catch (_) {
		return false;
	}
};

/**
 * Get SB seting if we can use cashout
 */
export const useCashout = async () => {
	try {
		const settings = await getSettings();
		return settings.Settings[BETSLIP_SETTINGS.USE_CASHOUT] === 'true';
	} catch (_) {
		return false;
	}
};

export const useCashoutV2tCalculation = async () => {
	try {
		const settings = await getSettings();
		return settings.Settings[BETSLIP_SETTINGS.CASHOUT_V2_ENABLE] === 'true';
	} catch (_) {
		return false;
	}
};


export const useForeCastTricast = async () => {
	try {
		const settings = await getSettings();
		return settings.Settings[BETSLIP_SETTINGS.ENABLE_FORECAST_TRICAST] === 'true';
	} catch (_) {
		return false;
	}
};